<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/shebei/filterEarly')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!--  -->
    <div class="color0063ea fw-600 mgb-15">预警设备</div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="equipmentNum" label="设备编号"> </el-table-column>
      <el-table-column prop="name" label="设备名称"> </el-table-column>
      <!-- <el-table-column prop="companyName" label="所属企业"> </el-table-column> -->
      <el-table-column prop="regionName" label="所属分区"> </el-table-column>
      <el-table-column prop="place" label="铺设位置"> </el-table-column>
      <el-table-column prop="createTime" label="预警时间"> </el-table-column>
      <el-table-column prop="status" label="预警状态">
        <template slot-scope="scope">
          <span v-text="scope.row.status == 0 ? '待跟进' : '已跟进'"></span>
        </template>
      </el-table-column>
    </el-table>
    <div class="color0063ea fw-600 mgb-15 mgt-50">耗材信息</div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="filterName" label="滤芯名称"> </el-table-column>
      <el-table-column prop="name" label="滤芯等级"> </el-table-column>
      <el-table-column prop="address" label="滤芯模式">
        <template slot-scope="scope">
          <span v-text="scope.row.type == 1 ? '计量' : '计时'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="waterCount" label="当前已净水总量(吨)">
      </el-table-column>
      <el-table-column prop="updateTime" label="滤芯更换时间">
        <template slot-scope="scope">
          <span
            v-text="scope.row.updateTime ? scope.row.updateTime : '- -'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="endTime" label="滤芯到期时间"> </el-table-column>
      <el-table-column prop="warningValue" label="预警余量(%)">
      </el-table-column>
      <el-table-column prop="residuelife" label="当前剩余百分比(%)">
      </el-table-column>
      <el-table-column prop="watercount" label="净水量(吨)"> </el-table-column>
    </el-table>
    <div class="color0063ea fw-600 mgb-15 mgt-50" v-if="type == 1">
      跟进详情
    </div>
    <el-table :data="tableData" border style="width: 100%" v-if="type == 1">
      <el-table-column prop="addUserName" label="跟进人员"> </el-table-column>
      <el-table-column prop="updateTime" label="跟进时间"> </el-table-column>
      <el-table-column prop="remark" label="跟进备注"> </el-table-column>
      <el-table-column prop="address" label="图片">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            v-for="(v, i) in srcList"
            :key="i"
            :src="v"
            :preview-src-list="srcList"
          >
          </el-image>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      tableData: [],
      type: null,
      srcList: [],
    };
  },
  created() {
    this.$route.query.data.status == 0 ? (this.type = 0) : (this.type = 1);
    this.tableData = [this.$route.query.data];
    this.tableData.forEach((v) => {
      if (v.createTime && v.changeTime) {
        v.endTime = this.addDaysToDate(v.createTime, v.changeTime);
      }
    });
    if (this.tableData[0].followPhoto) {
      this.srcList = this.tableData[0].followPhoto.split(",");
    }
  },
  methods: {
    addDaysToDate(startDate, days) {
      const startDateObj = new Date(startDate);
      const millisecondsToAdd = days * 24 * 60 * 60 * 1000;

      // 计算相加后的时间（以毫秒为单位）
      const resultTime = startDateObj.getTime() + millisecondsToAdd;

      // 创建新的Date对象来表示相加后的日期

      const resultDate = new Date(resultTime);

      // 格式化日期字符串（年-月-日 时:分:秒）
      const formattedResult = resultDate
        .toISOString()
        .replace("T", " ")
        .slice(0, 19);

      return formattedResult;
    },
  },
};
</script>

<style lang="scss" scoped></style>
